import resetState from '../Utils/reset-state'
export default {
    mutateCommonProperties (state, payload) {
      state.commonObj = Object.assign({}, state.commonObj, payload)
    },
    mutateDropdownCommonConfig (state, payload) {
      state.commonObjCommonConfig = Object.assign({}, state.commonObjCommonConfig, payload)
    },
    mutateWarehouseProperties (state, payload) {
        state.warehouse = Object.assign({}, state.warehouse, payload)
    },
    mutateAgriMarketingProperties (state, payload) {
        state.agriMarketing = Object.assign({}, state.agriMarketing, payload)
    },
    changeCommonDropdown (state, payload) {
      state.commonObj.countryList = state.commonObj.countryList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.divisionList = state.commonObj.divisionList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.districtList = state.commonObj.districtList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.upazilaList = state.commonObj.upazilaList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.unionList = state.commonObj.unionList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.cityCorporationList = state.commonObj.cityCorporationList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.pauroshobaList = state.commonObj.pauroshobaList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.wardList = state.commonObj.wardList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.organizationProfileList = state.commonObj.organizationProfileList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.officeTypeList = state.commonObj.officeTypeList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.officeList = state.commonObj.officeList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.genderList = state.commonObj.genderList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.designationList = state.commonObj.designationList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.subDesignationList = state.commonObj.subDesignationList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.gradeList = state.commonObj.gradeList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.zoneList = state.commonObj.zoneList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.fiscalYearList = state.commonObj.fiscalYearList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.orgList = state.orgList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.instituteTypeList = state.commonObj.instituteTypeList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.maritalStatus = state.commonObj.maritalStatus.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.portalServiceCategoryList = state.commonObj.portalServiceCategoryList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.portalServiceCustomerTypeList = state.commonObj.portalServiceCustomerTypeList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.monthList = state.commonObj.monthList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.subOccupationList = state.commonObj.subOccupationList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObj.facilityList = state.commonObj.facilityList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
    },
    localizeDropdownCommonConfig (state, payload) {
      state.commonObjCommonConfig.componentList = state.commonObjCommonConfig.componentList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObjCommonConfig.moduleList = state.commonObjCommonConfig.moduleList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObjCommonConfig.menuList = state.commonObjCommonConfig.menuList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObjCommonConfig.buttonTypeList = state.commonObjCommonConfig.buttonTypeList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObjCommonConfig.mediaList = state.commonObjCommonConfig.mediaList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObjCommonConfig.recipientList = state.commonObjCommonConfig.recipientList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
      state.commonObjCommonConfig.messageTemplateList = state.commonObjCommonConfig.messageTemplateList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text } : { text: item.text }
        return Object.assign({}, item, tmp)
      })
    },
    changeWarehouseDropdown (state, payload) {
        state.warehouse.commodityGroupList = state.warehouse.commodityGroupList.map(item => {
          const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
          return Object.assign({}, item, tmp)
        })
        state.warehouse.commodityNameList = state.warehouse.commodityNameList.map(item => {
          const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
          return Object.assign({}, item, tmp)
        })
        state.warehouse.regionList = state.warehouse.regionList.map(item => {
          const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
          return Object.assign({}, item, tmp)
        })
        state.warehouse.warehouseDesignationList = state.warehouse.warehouseDesignationList.map(item => {
          const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
          return Object.assign({}, item, tmp)
        })
        state.warehouse.warehouseTypeList = state.warehouse.warehouseTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.warehouse.warehouseInfoList = state.warehouse.warehouseInfoList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.warehouse.warehouseLevelList = state.warehouse.warehouseLevelList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.warehouse.fiscalYearList = state.warehouse.fiscalYearList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.warehouse.warehouseCategoryList = state.warehouse.warehouseCategoryList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.warehouse.serviceTypeList = state.warehouse.serviceTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.warehouse.marketInfoList = state.warehouse.marketInfoList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.patientTypeList = state.commonObj.patientTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    changeAgriMarketingDropdown (state, payload) {
        /* state.agriMarketing.regionList = state.agriMarketing.regionList.map(item => {
            const en = item.text
            const tmp = payload.value === 'en' ? { text: item.text } : { text: item.text_bn }
            return Object.assign({}, item, tmp, { text_en: en })
        }) */
    },
    setOrgAndOrgComponentList (state, payload) {
      state.orgList = payload.orgList
      state.orgComponentList = payload.orgComponentList
    },
    setList (state, payload) {
      state.list = payload
    },
    resetList (state, payload) {
      state.list = payload
    },
    setNotificationList (state, payload) {
      state.notificationList = payload
    },
    setPushNotification (state, payload) {
      state.isPushNotification.push(payload)
    },
    removeSinglePushNotification (state, payload) {
      state.isPushNotification.splice(state.isPushNotification.indexOf(payload))
    },
    setTotalNotification (state, payload) {
      state.totalNotification = payload
    },
    isToggleNotification (state, payload) {
      state.toggleNotification = payload
    },
    removeItemFromSetList (state, payload) {
      const index = state.list.findIndex(item => item.id === payload)
      state.list.splice(index, 1)
    },
    toggleStatus (state, payload) {
      state.list = state.list.map(function (item) {
        if (item.id === payload.id && item.status === 2) {
          return Object.assign(item, { status: 1 })
        } else if (item.id === payload.id && item.status === 0) {
          return Object.assign(item, { status: 1 })
        }
        return item
      })
    },
    // for farmer request reject
    toggleRejectItemStatus (state, payload) {
        state.commonObj[payload.dropdownName] = state.commonObj[payload.dropdownName].map(item => {
            if (item.value === payload.itemId) {
              return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
            }
            return item
          })
    },
    toggleDropdownItemStatus (state, payload) {
      if (payload.destination === 'common') {
        state.commonObj[payload.dropdownName] = state.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status ? 0 : 1 })
          }
          return item
        })
      } else if (payload.destination === 'production') {
          state.ProductionService.commonObj[payload.dropdownName] = state.ProductionService.commonObj[payload.dropdownName].map(item => {
            if (item.value === payload.itemId) {
              return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
            }
            return item
          })
      } else if (payload.destination === 'common_config') {
        state.commonObjCommonConfig[payload.dropdownName] = state.commonObjCommonConfig[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status ? 0 : 1 })
          }
          return item
        })
      } else if (payload.destination === 'hospital') {
        state.HospitalDisabilityService.commonObj[payload.dropdownName] = state.HospitalDisabilityService.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else if (payload.destination === 'child_service') {
        state.ChildService.commonObj[payload.dropdownName] = state.ChildService.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else if (payload.destination === 'grant_allowance_service') {
        state.GrantAllowanceService.commonObj[payload.dropdownName] = state.GrantAllowanceService.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else if (payload.destination === 'awareness_event_service') {
        state.AwarenessEventService.commonObj[payload.dropdownName] = state.AwarenessEventService.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else if (payload.destination === 'disability_school_service') {
        state.DisabilitySchoolService.commonObj[payload.dropdownName] = state.DisabilitySchoolService.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else if (payload.destination === 'training_e_learning_service') {
        state.TrainingElearning.commonObj[payload.dropdownName] = state.TrainingElearning.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else if (payload.destination === 'social_welfare') {
        // state.SocialWelfare.commonObj[payload.dropdownName] = state.SocialWelfare.commonObj[payload.dropdownName].map(item => {
        state.SocialWelfareService.commonObj[payload.dropdownName] = state.SocialWelfareService.commonObj[payload.dropdownName].map(item => {
          if (item.value === payload.itemId) {
            return Object.assign(item, { status: item.status === 2 ? 1 : 2 })
          }
          return item
        })
      } else {
        // Nothing to do
      }
    },
    resetState (state) {
      resetState(state)
    },
    setNotification (state, payload) {
        state.commonObj.notificationso = payload
    },
    setDataFilteringParam (state, payload) {
      state.dataFilters = Object.assign({}, state.dataFilters, payload)
    },
    setCurrentFiscalYearId (state, payload) {
        state.currentFiscalYearId = payload
    }
  }
